export const ANALYTIC_MENU_COMPONENT_NAME = 'AnalyticsMenu';

export default {};
